import React from "react";

interface SkeletonBlockProps {
  className?: string;
  style?: React.CSSProperties;
}

const SkeletonBlock: React.FC<SkeletonBlockProps> = ({ className = "", style }) => (
  <div
    role="status"
    aria-label="Loading"
    className={`animate-skeleton-shimmer rounded ${className}`}
    style={style}
  />
);

export default SkeletonBlock;
